export default "__VITE_ASSET__CkBgb84k__"